<template>
  <div>
    <h1 class="page-header">{{ $t('inventory.setup.warehouse.warehouse') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('inventory.setup.warehouse.location')
              }}</label>
              <input
                v-model="model.location_name"
                type="text"
                class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('location_name') }"
                :placeholder="$t('inventory.setup.warehouse.enterLocation')"
              />
              <div class="invalid-feedback" v-if="errors.has('location_name')">
                {{ errors.first('location_name') }}
              </div>
            </div>
            <div class="form-group">
              <ts-checkbox v-model="model.is_main_warehouse">{{
                $t('inventory.setup.warehouse.mainWarehouse')
              }}</ts-checkbox>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'warehouse-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        location_id: '',
        location_name: '',
        is_main_warehouse: false
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('warehouse', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('warehouse/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('warehouse/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('warehouse/SET_EDIT_DATA', {})
      this.$router.push({ name: 'warehouse' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('warehouse/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        location_id: '',
        location_name: '',
        is_main_warehouse: false
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('warehouse/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
